import { sendSlackMessage, SlackMessage } from './slackBase';

export const notifySlackError = async (
	message: SlackMessage,
	source?: string,
): Promise<void> => {
	const webhookUrl = process.env.REACT_APP_SLACK_ERROR || '';
	await sendSlackMessage(webhookUrl, 'ATLAS', 'error', message);
};

export const notifySlackSuccess = async (
	message: SlackMessage,
	source?: string,
): Promise<void> => {
	const webhookUrl = process.env.REACT_APP_SLACK_SUCCESS || '';
	await sendSlackMessage(webhookUrl, 'ATLAS', 'success', message);
};

export const notifyWithdraw = async (
	message: SlackMessage,
	status?: 'success' | 'error',
): Promise<void> => {
	const webhookUrl = process.env.REACT_APP_SLACK_WITHDRAW || '';
	await sendSlackMessage(webhookUrl, 'ATLAS', status ?? 'success', message);
};

export const notifyDeposit = async (
	message: SlackMessage,
	status?: 'success' | 'error',
): Promise<void> => {
	const webhookUrl = process.env.REACT_APP_SLACK_DEPOSIT || '';
	await sendSlackMessage(webhookUrl, 'ATLAS', status ?? 'success', message);
};
